<template>
  <div class="c-resource-card" @click="$emit('resource-click',resource)">
    <div>
      <file-icon v-if="!['policies','page','eform','survey'].includes(resource.type) && resource.name" :type="resource.name|extension"></file-icon>
      <file-icon v-else-if="!['page','eform','survey'].includes(resource.type)" type="pdf"></file-icon>
      <file-icon v-else type="link"></file-icon>
    </div>
    <div>{{resource.name}}</div>
  </div>
</template>

<script>
export default {
  name: "ResourceCard",

  props: {
    resource: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.c-resource-card {
  display: flex;
  flex-direction: row;
  justify-content: baseline;
  align-items: center;
  cursor: pointer;
  padding-bottom: 20px;

  div {
    padding: 10px;
    box-sizing: border-box;
  }

}
</style>